import { render, staticRenderFns } from "./contact_dialog.vue?vue&type=template&id=1236e0be&scoped=true&"
import script from "./contact_dialog.vue?vue&type=script&lang=js&"
export * from "./contact_dialog.vue?vue&type=script&lang=js&"
import style0 from "./contact_dialog.vue?vue&type=style&index=0&id=1236e0be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236e0be",
  null
  
)

export default component.exports